<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
import integralCategories from "./integralCategories.vue";
import integralList from "./integralList.vue";
import integralSpecifications from "./integralSpecifications.vue";
import integralSignin from "./integralSignin.vue";
import integralDetail from "./integralDetail.vue";
let tabBox = {
  '商品列表': {property: 'integralList'},
  '商品分类': {property: 'integralCategories'},
  '商品规格': {property: 'integralSpecifications'},
  '签到': {property: 'integralSignin'},
  '积分明细': {property: 'integralDetail'}
}

export default {
  name: "integral",
  components: {
    integralCategories,
    integralList,
    integralSpecifications,
    integralSignin,
    integralDetail
  },
  data() {
    return {
      meaulistTab: this.meaulist.meaulistGet(this, tabBox),
      activeName:''
    };
  },
  created() {
    this.inittab();
  },
  methods: {
    inittab() {
      this.activeName =
        this.$route.query.tab !== undefined
          ? this.$route.query.tab
          : "integralList";
    },
    tabCurrentFn(index){
      this.meaulistTab.firstTab = index
    }
  }
};
</script>
